export default __webpack_public_path__ + "static/media/register-bg.21842acd.png";